import { useContext } from "react";
import { DrawerContext } from "../providers/drawer.context";

export function useDrawer() {
  return useContext(DrawerContext);
}
